import { Component, OnInit , ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication.service';
import { Router } from '@angular/router';
import { GmsmenuService } from '../core/services/gmsmenu.service';

@Component({
    selector: 'app-gms-logout',
    templateUrl: './gms-logout.component.html',
    styleUrls: ['./gms-logout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmsLogoutComponent implements OnInit {
  public userName: string = null;
  constructor(private authSer: AuthenticationService, private router: Router, private gmsMenusSer: GmsmenuService) {
    // this.userName = this.authSer.userName;
    // console.log('userName:', this.userName);
    let un = sessionStorage.getItem('userName');
    if (un === undefined || un === null) {
      this.userName = this.authSer.userName;
      sessionStorage.setItem("userName", this.userName);
    } else {
      this.userName = un;
    }
  }

  ngOnInit(): void {

  }
  public logOut() {
    this.authSer.doLogOut().subscribe((response: any) => {
      this.authSer.sessionValue = null;
      this.authSer.clearSession();
      sessionStorage.clear();
      sessionStorage.removeItem("userName");
      this.gmsMenusSer.clearGmsMenuSession();
      this.router.navigate(['/login']);
    });
  }
}
